module.exports = __webpack_public_path__ + "img/loved.abd6197c.png";